import { card as en_card } from "../en/card";

/** card — ES slice (75 keys). */
export const card: Record<keyof typeof en_card, string> = {
  card_toasts_region_label: "Notificaciones",
  card_loading: "Cargando…",
  card_load_failed: "No se pudo cargar tu tarjeta. Desliza para actualizar.",
  card_write_unavailable_try_again: "Algo salió mal, inténtalo de nuevo.",
  card_action_share: "Compartir tarjeta",
  card_action_copy_link: "Copiar enlace",
  card_action_more: "Más",
  card_action_contact: "Contacto",
  card_action_coming_soon: "Muy pronto",
  card_action_link_copied: "Enlace copiado.",
  card_item_kind_phone_label: "Teléfono",
  card_item_kind_email_label: "Correo",
  card_item_kind_instagram_label: "Instagram",
  card_item_kind_tiktok_label: "TikTok",
  card_item_kind_linkedin_label: "LinkedIn",
  card_item_kind_x_label: "X",
  card_item_kind_youtube_label: "YouTube",
  card_item_kind_url_label: "Enlace",
  card_editor_entry_label: "Editar tarjeta",
  card_no_items_placeholder:
    "Añade un contacto, red social o enlace para compartir.",
  card_editor_phase_4_placeholder: "El editor llega en la Fase 4",
  card_retry: "Reintentar",
  card_editor_save_button: "Guardar",
  card_editor_cancel_button: "Cancelar",
  card_editor_remove_button: "Eliminar",
  card_editor_section_identity: "IDENTIDAD",
  card_editor_section_style: "ESTILO",
  card_editor_section_contact: "CONTACTO",
  card_editor_section_socials: "REDES",
  card_editor_section_links: "ENLACES",
  card_editor_identity_display_name_label: "Nombre visible",
  card_editor_identity_bio_label: "Biografía",
  card_editor_identity_avatar_label: "Avatar",
  card_editor_identity_avatar_change: "Cambiar",
  card_editor_style_theme_label: "Tema",
  card_editor_add_contact_row: "+ Añadir contacto",
  card_editor_add_social_row: "+ Añadir red social",
  card_editor_add_link_row: "+ Añadir enlace",
  card_editor_add_picker_title_contact: "Añadir contacto",
  card_editor_add_picker_title_social: "Añadir red social",
  card_items_cap_reached_hint:
    "Alcanzaste el límite de 30 elementos. Elimina uno para añadir otro.",
  card_items_cap_reached: "Límite de elementos alcanzado, no se pudo guardar.",
  card_save_failed_generic:
    "No se pudo guardar tu tarjeta. Inténtalo de nuevo.",
  card_link_not_allowed: "Este enlace no está permitido en Linqx.",
  card_theme_picker_title: "Tema",
  card_theme_picker_badge_free: "Gratis",
  card_theme_picker_badge_premium: "Premium",
  card_theme_picker_prev: "Tema anterior",
  card_theme_picker_next: "Tema siguiente",
  card_theme_premium_locked: "Los temas premium aún no están disponibles.",
  card_item_sheet_phone_label_header: "NÚMERO DE TELÉFONO",
  card_item_sheet_email_label_header: "CORREO ELECTRÓNICO",
  card_item_sheet_email_format_hint: "Formato: nombre@dominio.com",
  card_item_sheet_label_label_header: "ETIQUETA",
  card_item_sheet_url_label_header: "URL",
  card_item_sheet_url_error: "La URL debe comenzar con http:// o https://",
  card_item_sheet_label_counter: "{count} / 50",
  card_item_sheet_title_custom_link: "Enlace personalizado",
  card_lite_explainer_text:
    "Los datos de contacto se desbloquean cuando os conocéis: solicita conectar para compartir tu información de contacto.",
  card_lite_request_to_connect: "Solicitar conectar",
  card_lite_request_sent: "Solicitud enviada",
  card_lite_request_sent_success:
    "Solicitud enviada: verás su información de contacto cuando ambos lo confirméis.",
  card_lite_cannot_connect_to_self:
    "No puedes solicitar conectar contigo mismo.",
  card_unavailable_title: "Tarjeta no disponible",
  card_unavailable_message:
    "Esta tarjeta ya no está disponible. Es posible que su propietario haya eliminado su cuenta.",
  card_unavailable_back_button: "Atrás",
  card_share_action_label: "Compartir tarjeta",
  card_launcher_tab_title: "Mi tarjeta",
  card_launcher_tab_subtitle:
    "Tu tarjeta de contacto digital vive en la mini-app MyLinqx Card: ábrela para ver, editar y compartir.",
  card_launcher_tab_open_button: "Abrir MyLinqx Card",

  // MyLinqx Card — lista de conexiones + traspaso a mensajes desde la tarjeta
  connections_title: "Conexiones",
  connections_empty_heading: "Aún no tienes conexiones",
  connections_empty_body:
    "Las personas aparecen aquí cuando ambos confirmáis vuestro encuentro.",
  connections_message_button: "Escribir a {name}",
  connections_message_button_short: "Mensaje",
  connections_load_failed:
    "No se pudieron cargar tus conexiones. Inténtalo de nuevo.",
};
